import { createContext, useContext } from 'react';

import type { AddConnectionModalProps } from './AddConnectionModal';
import type { EntityFormsContext } from './getEntityForms';
import type { RemoveConnectionModalProps } from './RemoveConnectionModal';

interface AddConnectionModal {
	isOpen: boolean;
	params: AddConnectionModalProps | null;
	open: (params: AddConnectionModalProps) => void;
	close: () => void;
}

interface FormModal {
	isOpen: boolean;
	params: EntityFormsContext | null;
	open: (params: EntityFormsContext) => void;
	close: () => void;
}

interface RemoveConnectionModal {
	isOpen: boolean;
	params: RemoveConnectionModalProps | null;
	open: (params: RemoveConnectionModalProps) => void;
	close: () => void;
}

interface ConnectionsMenu {
	isOpen: boolean;
	params: { entityId?: number } | null;
	open: (params: { entityId?: number }) => void;
	close: () => void;
}

interface ModalsControllerContext {
	addConnectionModal: AddConnectionModal;
	removeConnectionModal: RemoveConnectionModal;
	formModal: FormModal;
	connectionsMenu: ConnectionsMenu;
}

const ModalsControllerContext = createContext<ModalsControllerContext | null>(null);

export const ModalsControllerProvider = ModalsControllerContext.Provider;

export const useModalsController = () => {
	const context = useContext(ModalsControllerContext);
	if (!context) {
		return null;
	}
	return context;
};
